import React, { useState } from "react";
import { Button } from "@mui/material";
import { Search } from "@mui/icons-material";
import { SearchUserDialog } from "../dialogs/SearchUserDialog";

interface SearchBoxProps {
    onSearch?: (searchValue: string) => void;
}

export const SearchBox: React.FC<SearchBoxProps> = ({ onSearch }) => {
    const [open, setOpen] = useState(false);
    const handleSearch = (value: string) => {
        if (onSearch) onSearch(value);
    };
    return (
        <>
            <Button variant="outlined" startIcon={<Search />} onClick={() => setOpen(true)}>
                Search
            </Button>
            <SearchUserDialog
                open={open}
                onClose={() => setOpen(false)}
                onSearch={handleSearch}
            />
        </>
    );
};
